import {useEffect, useState} from "react";
import {closePopup2, selectEvent} from "utils/CommonUtils";
import {handleInput} from "utils/wordCheckUtils";
import cross from "assets/icon/cross.svg";
import plus from "assets/icon/plus.svg";
import {setOrderFreeDeliveryApi} from "api/costApi";


const FreeDelivery = ({shopId, minOrderCost, list}) => {
  const distList = [1, 1.5, 2, 2.5, 3, 3.5, 4];
  const [startValue, setStartValue] = useState(1);
  const [selectList, setSelectList] = useState([]);
  const [resetCount, setResetCount] = useState(1);

  useEffect(() => {
    const listData = list.length === 0 ? [{id: 0, distance: 1, minOrderCost: minOrderCost}] : list;
    setSelectList(listData);
    setStartValue(listData[0].distance);
  }, [minOrderCost, list, resetCount]);

  const selectChangeEvent = (index, distance) => {
    setSelectList((prevList) => {
      let updatedList = [...prevList];
      updatedList[index] = { ...updatedList[index], distance: distance };
      updatedList = updatedList.sort((a, b) => a.distance - b.distance);
      updatedList[0] = { ...updatedList[0], minOrderCost: minOrderCost }
      setStartValue(updatedList[0].distance);
      return updatedList; // 업데이트된 리스트 반환
    });
    selectEvent(`freeDistSelect${index}`, distance, distance);
  }

  const addEvent = () => {
    let distanceValue = 0;

    distList.forEach((number) => {
      const isChecked = selectList.some((item) => item["distance"] === number);
      if (!isChecked) distanceValue = number;
    });

    if (distanceValue !== 0) {
      setSelectList((prevList) => {
        let updatedList = [...prevList, {id: 0, distance: distanceValue, minOrderCost: 0}];
        return updatedList.sort((a, b) => a.distance - b.distance);
      });
    }
  }

  const deleteEvent = (id, index) => {
    setSelectList((prevList) => {
      return  prevList.filter((_, i) => i !== index);
    });

  }

  const closeEvent = () => {
    closePopup2("freeDeliveryPopup")
    setResetCount(resetCount + 1);
  }

  const setEvent = async () => {
    let addFreeDeliveryCostList = [];
    let setFreeDeliveryCostList = [];

    selectList.forEach((value, index) => {
      const distCost = Number(document.getElementById(`freeDistCost${index}`).value);

      if (value.id !== 0) {
        setFreeDeliveryCostList.push({
          freeDeliveryCostId: value.id,
          distance: value.distance,
          minOrderCost: distCost
        });
      } else {
        addFreeDeliveryCostList.push({
          distance: value.distance,
          minOrderCost: distCost
        });
      }
    });

    const selectIds = new Set(selectList.map((item) => item.id));
    const nonMatchingIds = list
      .filter((item) => !selectIds.has(item.id))
      .map((item) => item.id);

    const data = {
      shopId: shopId
    }

    if (addFreeDeliveryCostList.length > 0) data.addFreeDeliveryCostList = addFreeDeliveryCostList;
    if (setFreeDeliveryCostList.length > 0) data.setFreeDeliveryCostList = setFreeDeliveryCostList;
    if (nonMatchingIds.length > 0) data.removeFreeDeliveryCostIdList = nonMatchingIds;

    await setOrderFreeDeliveryApi(data);
    window.location.reload();
  }

  return (
    <div className="newStyle">
      <div id="freeDeliveryPopup" className="freeDeliveryPopup popupContainer d-flex a-center j-center d-none">
        <div className="popupBody bc-FF">
          <div className="titleBox d-flex a-center j-between">
            <p className="fs-24 fw-7">거리별 무료 배달비 설정</p>
            <button onClick={closeEvent}>
              <img className="crossImage" src={cross} alt="닫기" />
            </button>
          </div>
          <div className="bodyBox scrollbar">
            {selectList.map((value, index) => {
              return (
                <div key={index} className={`popupInputBox inputBox d-flex a-center j-left ${index === 0 ? "" : "mt-15"}`}>
                  <div id={`freeDistSelect${index}`} className="w-60 select2 bc-FF br-6 mr-10">
                    <div className="selectText2 ellipsis-1" data-href={`freeDistSelect${index}`} data-id={value.distance}>
                      {value.distance}
                    </div>
                    <div id={`freeDistSelect${index}Ul`} className="selectOptionListBox2 scrollbar d-none bc-FF br-6">
                      {distList.map((number) => {
                        const isChecked = selectList.some((item) => item["distance"] === number);
                        const isCurrentValue = number === value.distance;
                        const isValidNumber = number > startValue && !isChecked;
                        const isIndex = index === 0 && !isChecked;

                        if (isCurrentValue || isValidNumber || isIndex) {
                          return (
                            <div
                              key={number}
                              className="ellipsis-1"
                              onClick={() => selectChangeEvent(index, number)}
                            >
                              {number}
                            </div>
                          );
                        }

                        return null;
                      })}
                    </div>
                  </div>
                  km&nbsp;&nbsp;이내
                  <input
                    id={`freeDistCost${index}`}
                    className="w-120 ml-5 mr-5 br-6"
                    key={`freeDistCost-${value.minOrderCost}`}
                    type="text"
                    defaultValue={index !== 0 ? value.minOrderCost : minOrderCost}
                    maxLength={8}
                    onInput={(e) => handleInput(e, "number")}
                  />
                  원
                  <button className="deleteBtn ml-10 br-6" onClick={() => deleteEvent(value.id, index)}>
                    <img className="plusImage" src={plus} alt="삭제" />
                  </button>
                </div>
              );
            })}
            {selectList.length < 5 &&
              <button className="addBtn br-6 fc-0764A9 mt-15 fw-7" onClick={addEvent}>
                <img className="mr-5 plusImage" src={plus} alt="추가" />
                추가
              </button>
            }
          </div>
          <div className="btnBox d-flex a-center j-between">
            <button
              className="fs-20 fw-7 bc bc-ACB2B8 fc-FF"
              onClick={closeEvent}
            >
              취소
            </button>
            <button className="fs-20 fw-7 bc-0764A9 fc-FF" onClick={setEvent}>수정</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeDelivery;